import { useTranslation } from 'next-i18next'
// Imports
import styled from 'styled-components'

import { Modal, Props as ModalProps } from '../Modal'
import { icons } from '../../utils'
import { H3 } from '../H3'
import { P } from '../P'
import { CTA } from '../CTA'
import { Hyperlink } from '../Hyperlink'

// Props
type Props = ModalProps

// Components
export const DiscardModal: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props.
  const { close } = props

  return (
    <Modal close={close} retainPointerEvents={true} zIndex={9999}>
      <Div>
        <Hyperlink href="/myevents">
          <button className="closeBtn" onClick={close}>
            <svg
              width="24"
              height="24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.625 6.875l-10 10M6.625 6.875l10 10"
                stroke="#6D4BEA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </Hyperlink>
        <Content>
          <H3>
            {t(
              `DiscardModal-967807017`,
              `Are you sure you want to leave creating this event?`,
            )}
          </H3>

          <P>
            {t(
              `DiscardModal-614510552`,
              `If you leave this page all information will to it will be lost.`,
            )}
          </P>

          <CTA onClick={close} className="purple">
            {t(`DiscardModal105183144`, `Continue creating event`)}
          </CTA>

          <Hyperlink href="/myevents/hosting">
            <CTA>{t(`DiscardModal500596619`, `Discard creating event`)}</CTA>
          </Hyperlink>
        </Content>
      </Div>
    </Modal>
  )
}

// Styled Components
const Div = styled.div`
  z-index: 1;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  width: 100%;
  max-width: 600px;
  height: 424px;
  background: #fff;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-align: center;

  .closeBtn {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background: #f0edfd;
    border: none;
    border-radius: 100px;
  }
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  max-width: 364px;

  ${P} {
    margin: 20px auto;
  }

  a {
    text-decoration: none;
  }

  ${CTA} {
    display: block;
    width: 220px;
    margin-top: 15px;
  }
`
